import Chatbot from "https://cdn.jsdelivr.net/npm/flowise-embed/dist/web.js";

Chatbot.init({
	chatflowid: "a465d69a-8c94-4acd-bc15-efcf97a3fb98",
	apiHost: "https://flowise.hooky-studio.com",
	chatflowConfig: {
		/* Chatflow Config */
	},
	observersConfig: {
		/* Observers Config */
	},
	theme: {
		button: {
			backgroundColor: "#3B81F6",
			right: 20,
			bottom: 20,
			size: 48,
			dragAndDrop: true,
			iconColor: "white",
			customIconSrc: "/images/chat.png",
			autoWindowOpen: {
				autoOpen: false,
				openDelay: 2,
				autoOpenOnMobile: false,
			},
		},
		tooltip: {
			showTooltip: true,
			tooltipMessage: "Besoin d'aide ? 👋",
			tooltipBackgroundColor: "black",
			tooltipTextColor: "white",
			tooltipFontSize: 16,
		},
		customCSS: ``,
		chatWindow: {
			showTitle: true,
			showAgentMessages: true,
			title: "Assistant Wooky",
			titleAvatarSrc: "/images/groovy.png",
			welcomeMessage:
				"Bonjour ! Je suis Wooky, l'assistant virtuel de Hooky. Je peux vous aider à configurer vos scènes, gérer votre bibliothèque ou répondre à vos questions techniques.",
			errorMessage:
				"Une erreur est survenue. Veuillez réessayer plus tard.",
			backgroundColor: "#ffffff",
			backgroundImage: "",
			height: 700,
			width: 400,
			fontSize: 16,
			starterPrompts: [
				"Comment créer une scène ?",
				"C'est quoi un générateur de playlist ?",
				"Comment ajouter mes propres musiques ?",
			],
			starterPromptFontSize: 15,
			clearChatOnReload: false,
			sourceDocsTitle: "Sources :",
			renderHTML: true,
			botMessage: {
				backgroundColor: "#f7f8ff",
				textColor: "#303235",
				showAvatar: true,
				avatarSrc: "/images/groovy.png",
			},
			userMessage: {
				backgroundColor: "#3B81F6",
				textColor: "#ffffff",
				showAvatar: true,
				avatarSrc: "/images/user.png",
			},
			textInput: {
				placeholder: "Posez votre question...",
				backgroundColor: "#ffffff",
				textColor: "#303235",
				sendButtonColor: "#3B81F6",
				maxChars: 400,
				maxCharsWarningMessage:
					"Vous avez dépassé la limite de caractères.",
				autoFocus: true,
				sendMessageSound: true,
				sendSoundLocation: "send_message.mp3",
				receiveMessageSound: true,
				receiveSoundLocation: "receive_message.mp3",
			},
			feedback: {
				color: "#303235",
			},
			dateTimeToggle: {
				date: true,
				time: true,
			},
			footer: {
				textColor: "#303235",
				text: "",
				company: "",
				companyLink: "https://hooky-studio.com",
			},
		},
	},
});
